exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ":root {\n  --tws-label-spacing: .5em;\n  --tws-label-color: hsla(var(--color-gray-75), 63%);\n  --tws-label-font: var(--font-light);\n  --tws-label-font-size: 0.875rem;\n}\n\n\n.t-very-dark-gray {\n  --tws-label-color: hsla(var(--color-15), 50%);\n}\n", ""]);

